// TODO(post-V1): replace OTP stub with real SMS provider (Twilio / MSG91).
// This wrapper is the only file the rest of the app talks to; swapping the
// provider means changing the Edge Functions only.

import { supabase } from './supabase';

export interface SendOtpResult {
  requestId: string;
  /** Present only while the stub is in place; surfaces the dev code to the UI banner. */
  devCode?: string;
}

export type VerifyOtpReason =
  'ok' | 'wrong_code' | 'expired' | 'too_many_attempts' | 'no_active_verification';

export interface VerifyOtpResult {
  ok: boolean;
  reason: VerifyOtpReason;
  remaining_attempts: number;
}

export class OtpError extends Error {
  constructor(
    message: string,
    readonly code: string,
  ) {
    super(message);
    this.name = 'OtpError';
  }
}

export async function sendOTP(): Promise<SendOtpResult> {
  const { data, error } = await supabase.functions.invoke<SendOtpResult>('otp-send', {
    body: {},
  });
  if (error !== null) {
    throw new OtpError(error.message, 'send_failed');
  }
  if (data === null || typeof data.requestId !== 'string') {
    throw new OtpError('OTP send returned no requestId', 'send_invalid_response');
  }
  return data;
}

export async function verifyOTP(code: string): Promise<VerifyOtpResult> {
  const { data, error } = await supabase.functions.invoke<VerifyOtpResult>('otp-verify', {
    body: { code },
  });
  if (error !== null) {
    throw new OtpError(error.message, 'verify_failed');
  }
  if (
    data === null ||
    typeof data.ok !== 'boolean' ||
    typeof data.reason !== 'string' ||
    typeof data.remaining_attempts !== 'number'
  ) {
    throw new OtpError('OTP verify returned an unexpected payload', 'verify_invalid_response');
  }
  return data;
}
